import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';

import CloneOffer from './submodules/clone';
import CreateOffer from './submodules/create';
import OfferList from './submodules/list';
import EditOffer from './submodules/edit';
import ActivateOffer from './submodules/activateOffer';
import { GET_ACTION, TDS_ABSORPTION_RESOURCES } from '../tdsHelper';
import { FINANCE_RESOURCES } from '../../helper';

const TdsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.tdsAbsorption}
				configResourceName={TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers}
				configActionName={GET_ACTION.tdsAbsorptionOffers.getTDSAbsorptionActiveOffers}
				path={`${path}/list`}
				component={OfferList}
				exact
			/>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.tdsAbsorption}
				configResourceName={TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers}
				configActionName={GET_ACTION.tdsAbsorptionOffers.createTDSAbsorptionOffers}
				path={`${path}/clone`}
				component={CloneOffer}
				exact
			/>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.tdsAbsorption}
				configResourceName={TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers}
				configActionName={GET_ACTION.tdsAbsorptionOffers.createTDSAbsorptionOffers}
				path={`${path}/create`}
				component={CreateOffer}
				exact
			/>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.tdsAbsorption}
				configResourceName={TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers}
				configActionName={GET_ACTION.tdsAbsorptionOffers.updateTDSAbsorptionOffers}
				path={`${path}/edit`}
				component={EditOffer}
				exact
			/>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.tdsAbsorption}
				configResourceName={TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers}
				configActionName={GET_ACTION.tdsAbsorptionOffers.activateTDSAbsorptionOffers}
				path={`${path}/activateOffer`}
				component={ActivateOffer}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default TdsDashboard;
